export const GET_PHYSICAL_CONNECTIONS = 'assetPhysicalConnection/GET_PHYSICAL_CONNECTIONS';
export const CLEAR_PHYSICAL_CONNECTIONS = 'assetPhysicalConnection/CLEAR_PHYSICAL_CONNECTIONS';
export const GET_PHYSICAL_CONNECTIONS_REQUEST = 'assetPhysicalConnection/GET_PHYSICAL_CONNECTIONS_REQUEST';
